import { Navigate, useSearchParams } from "react-router-dom";

import { getRedirectToFromParams } from "../helpers/routes";
import { useAuth } from "../providers/AuthProvider";
import { User } from "../types/User";

const InitialSetupRoute = ({
  me,
  children,
}: {
  me: User;
  children: JSX.Element;
}) => {
  const { getScopedPageUrl } = useAuth();
  const [searchParams] = useSearchParams();
  const redirectTo = getRedirectToFromParams(searchParams);

  if (me && me.initialSetupCompleted) {
    return (
      <Navigate to={`${redirectTo ? redirectTo : getScopedPageUrl("home")}`} />
    );
  }

  return children;
};

export default InitialSetupRoute;
